var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuPrivacyPolicy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#FEE6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.7815 8.04177L10.0332 9.70771C8.94894 10.1896 8.23345 11.2687 8.30244 12.4532C8.57216 17.0838 9.9282 19.1225 13.4518 21.508C14.3852 22.1399 15.6157 22.1415 16.5484 21.5085C20.0829 19.11 21.3904 17.0426 21.6838 12.4692C21.7603 11.2769 21.0436 10.1863 19.9519 9.7011L16.2184 8.04177C15.4427 7.69701 14.5572 7.69701 13.7815 8.04177Z",
    fill: "#DE8D8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6204 13.0767C17.8542 13.2813 17.8779 13.6366 17.6733 13.8704L15.5209 16.3303C15.0584 16.8589 14.2617 16.9297 13.7132 16.4909L12.3986 15.4392C12.156 15.2452 12.1167 14.8912 12.3108 14.6486C12.5048 14.406 12.8588 14.3667 13.1014 14.5608L14.416 15.6125C14.4944 15.6751 14.6082 15.665 14.6743 15.5895L16.8267 13.1296C17.0313 12.8958 17.3866 12.8721 17.6204 13.0767Z",
    fill: "#DE8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPrivacyPolicy);
export default __webpack_public_path__ + "static/media/menu_privacy_policy.6fede9e50b8f25a4ca3106a25d8f0ca8.svg";
export { ForwardRef as ReactComponent };